import { jobOpportunitySelector } from "./selector";
import DropDown from "../common/SearchableSelect";
import { useSelector, useDispatch } from "react-redux";
import { updateJobType, updateJobCategoryInMasterData, updateDropDownJobId, updateJobInfoDetails, setEMREHRSystemExperience, setMedicalSpecialities, setCertification, updatespecialitiesInMasterData, updatecertificationsInMasterData, updateemrEhrSystemExpInMasterData, updateEducationLevelInMasterData, setEducationDetails, updateDynamicFormData } from "./action";
import useConfiguration from "../../hooks/useConfiguration";
import { useEffect, useState } from "react";
import { updateJobcertificationsMasterData, updateJobemrEhrSystemExpMasterData, updateJobspecialitiesMasterData } from "./slice";

// eslint-disable-next-line import/no-anonymous-default-export
export default (props) => {
    const { masterData, jobType, education } = useSelector(jobOpportunitySelector);
    const dispatch = useDispatch();
    const config = useConfiguration();
    const [hideJobType, setHideJobType] = useState(false);

    //const [securityJob, setSecurityJob] = useState(false);

    // hideJobType = masterData?.allJobDomains.length !==1 ? true : false;   
    // console.log("1 ========>" + masterData)
    useEffect(() => {
        //   console.log(masterData)
        // If only one job domain/type is present, default the value
        if (masterData?.allJobDomains.length === 1) {
            dispatch(updateJobType(`${config.baseUrl}`, 'domain', masterData?.allJobDomains[0]));
        }
        if (masterData?.allJobTypes.length === 1) {
            dispatch(updateJobType(`${config.baseUrl}`, 'type', masterData?.allJobTypes[0]));
            if (masterData?.allJobCategory?.length === 0) {
                dispatch(updateJobCategoryInMasterData(`${config.baseUrl}`, 'type', masterData?.allJobTypes[0]));
            }
        }
    }, [masterData?.allJobDomains, masterData?.allJobTypes, masterData?.allJobCategory]);

    //console.log(masterData +"----------"+ masterData?.allJobTypes)
    useEffect(() => {
        if (masterData?.allJobTypes.length !== 1 && masterData?.allJobTypes.length !== 0) {
            setHideJobType(true);
        }
    }, [masterData])
    const updateJobTypeInfo = (target) => {
        const value = target.value
        dispatch(updateJobInfoDetails(`${config.baseUrl}`, 'jobCategory', null));
        dispatch(setEMREHRSystemExperience({
            definedExperience: [],
            otherExperience: [
                {
                    name: '',
                    mandatory: false
                }
            ]
        }));
        dispatch(setMedicalSpecialities({
            speciality: [],
            otherSpeciality: [
                {
                    name: '',
                    yearsOfExperience: 0
                }
            ]
        }));
        dispatch(setCertification({
            definedCertification: [],
            otherCertification: [
                {
                    name: '',
                    mandatory: false
                }
            ]
        }));

        dispatch(setEducationDetails({ ...education, level: undefined }));
        //console.log(target.value,'onchage');     
        dispatch(updateJobType(`${config.baseUrl}`, target.name, target.value));
        if (target.name === 'type') {
            dispatch(updateDropDownJobId(value?.id));
            dispatch(updateEducationLevelInMasterData(`${config.baseUrl}`, target.name, target.value));
            dispatch(updateJobCategoryInMasterData(`${config.baseUrl}`, target.name, target.value));
            // dispatch(updatespecialitiesInMasterData(`${config.baseUrl}`, target.name, target.value));
            // dispatch(updatecertificationsInMasterData(`${config.baseUrl}`, target.name, target.value));
            // dispatch(updateemrEhrSystemExpInMasterData(`${config.baseUrl}`, target.name, target.value));
            dispatch(updateDynamicFormData([]));
            dispatch(updateJobcertificationsMasterData([]));
            dispatch(updateJobspecialitiesMasterData([]));
            dispatch(updateJobemrEhrSystemExpMasterData([]));
        }
    };

    return (
        <>
            {
                hideJobType ?
                    <div className="card">
                        <div>
                            <div className="row">
                                <div className="card-header">
                                    <h3 class="card-title">Shift Type <span class="required">*</span></h3>
                                </div>
                                <div className="card-body">
                                    <div className="row">
                                    
                                        <DropDown name={'domain'}
                                            label={'Shift Domain'}
                                            star={'*'}
                                            id={'jobDomain'}
                                            options={masterData?.allJobDomains} multiple={false}
                                            updateValue={updateJobTypeInfo} isObject={true}
                                            value={[jobType?.domain]}
                                            disable={masterData?.allJobDomains.length === 1 ? true : false}
                                            errors={props.errors ? props.errors['domain'] : []}
                                        />
                                
                                        <DropDown name={'type'}
                                            label={'Shift Type'}
                                            id={'jobType'}
                                            options={masterData?.allJobTypes} multiple={false}
                                            updateValue={updateJobTypeInfo} isObject={true}
                                            value={[jobType?.type]}
                                            disable={masterData?.allJobTypes.length === 1 ? true : false}
                                            errors={props.errors ? props.errors['type'] : []}
                                        />
                                        
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div> : ''
            }
        </>
    )
}
